import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const serviceBlock = document.querySelector('.p-service__list');
if (serviceBlock) {
  let blockTl = gsap.timeline({
    scrollTrigger: {
      trigger: serviceBlock,
      start: 'top center+=20%',
      scrub: 1,
      end: () => '+=' + (serviceBlock.clientHeight - serviceBlock.clientHeight + 30),
      // markers: true
    }
  })
  
  const inners = serviceBlock.querySelectorAll('.p-service__items');
  inners.forEach(inner => {
    inner.style.transform = 'translate(80px, 0)';
    inner.style.opacity = 0;
  })

  blockTl.addLabel('start')
    .to('.p-service__items', {
      x: 0,
      opacity: 1,

      duration: 1,
      ease: "power1.inOut",
      stagger: {
        each: .5,
        from: 0
      }

    })
}